module.exports = "/packs/chevron-down-gray-e3082986d22b25b9692fb83f7e1f82a1.svg";